import React from 'react'
import { IconSparkles } from '@tabler/icons-react'

import { Pill } from '@/components/pills/Pill'

export const JumpToPill = ({ onClick, formattedTime, dataTestId, identity = 'moment' }) => {
  return (
    <Pill
      className="clickable"
      dataTestId={`jump-to-call-event-pill-${dataTestId}`}
      onClick={onClick}
      magical
      small
      icon={<IconSparkles />}
    >
      {`Jump to ${identity}:`}
      <div className="event-time">{formattedTime}</div>
    </Pill>
  )
}
